import { Row, Col } from "antd";

export const QrCodes = () => {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Row
        gutter={18}
        justify="center"
        style={{
          height: "100vh",
          alignItems: "center",
          maxWidth: "500px",
          marginBottom: "35px",
        }}
      >
        <Col span={24}>
          <img
            alt="qr-code contact information"
            width={"100%"}
            src="https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-haresh/qr-code-haresh-linkedin.png"
          />
        </Col>
        <Col span={24}>
          <img
            alt="qr-code contact information"
            width={"100%"}
            src="https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-haresh/qr-code-tpl.png"
          />
        </Col>
        <Col span={24}>
          <img
            alt="qr-code contact information"
            width={"100%"}
            src="https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-haresh/qr-code-tfg-call-to-action.png"
          />
        </Col>
      </Row>
      <br></br>
    </div>
  );
};
